import React from "react"
import { graphql } from "gatsby"
import { Asset } from "../../../../plugins/gatsby-plugin-atollon"
import StructuredText from "../custom-structured-text-renderer"
import parse from "html-react-parser"

const ContentClientImage = ({ richContent, image, gallery, title }) => {
  return (
    <section className="content-client-image">
      <div
        className="content-client-image__inner"
        data-sal="slide-up"
        data-sal-duration="1000"
        data-sal-easing="ease"
      >
        {richContent && (
          <div className="content-client-image__content">
            <div className="content-client-image__wrapper">
              {title && <h2>{parse(title)}</h2>}
              <StructuredText data={richContent} />

              {gallery?.length > 0 && (
                <div className="content-client-image__items">
                  {gallery.map((item, index) => (
                    <div className="content-client-image__item" key={index}>
                      <Asset asset={item} />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        {image && (
          <div className="content-client-image__image">
            <Asset asset={image} />
          </div>
        )}
      </div>
    </section>
  )
}

export default ContentClientImage

export const query = graphql`
  fragment ContentClientImageProps on DatoCmsContentClientImage {
    ... on DatoCmsContentClientImage {
      id
      title
      richContent {
        value
      }
      image {
        ...InternalAssetProps
      }
      gallery {
        ...InternalAssetProps
      }
    }
  }
`
